import type { JSX } from 'react';

interface LoadingScreenProps {
  message?: string;
}

// Full-page centered loading state. LOCAL copy (not a root re-export shim — arbi
// root has no standalone LoadingScreen; its auth loading lives inside AuthGuard).
// Mirrors arbi-dev's LoadingScreen verbatim so the cross-app transition is
// seamless. Used by AuthGate during auth + role resolution and during
// cross-subdomain redirects.
export default function LoadingScreen({ message }: LoadingScreenProps): JSX.Element {
  return (
    <div className="min-h-screen bg-surface-0 flex items-center justify-center">
      <div className="text-ink-muted text-sm">{message ?? 'Loading…'}</div>
    </div>
  );
}
